import React, { useState } from "react";
import { ChevronDown, ChevronUp, Star } from "lucide-react";
import { fmtD } from "../lib/date";

const trendOf = (rs) => {
  if (!rs || rs.length < 2) return 0;
  const recent = rs[0].score;
  const older = rs.slice(1).reduce((a, r) => a + r.score, 0) / (rs.length - 1);
  return Math.round((recent - older) * 10) / 10;
};

/* 分包商库卡片：PM 付款后评分（均分 × 次数 · 趋势 · 最近评语） */
export const SubRatingInsight = ({ c, zh }) => {
  const [open, setOpen] = useState(false);
  const rs = c.recentRatings || [];
  if (!c.pmRatingCount && rs.length === 0) return null;
  const trend = trendOf(rs);
  return (
    <div data-testid={`sc-pm-rating-${c.id}`} data-avg={c.pmRating} data-count={c.pmRatingCount} className="mt-2 rounded-md border border-amber-100 bg-amber-50/50 px-2 py-1.5 text-[10px]">
      <button onClick={() => setOpen((v) => !v)} className="w-full flex items-center gap-1.5 text-left" data-testid={`sc-pm-rating-toggle-${c.id}`}>
        <Star className="h-3 w-3 fill-amber-400 text-amber-500 shrink-0" />
        <span className="font-bold text-amber-800">{Number(c.pmRating || 0).toFixed(1)}★</span>
        <span className="text-slate-500">{zh ? `PM 评分 ×${c.pmRatingCount || rs.length}` : `PM ratings ×${c.pmRatingCount || rs.length}`}</span>
        {trend !== 0 && <span data-testid={`sc-pm-trend-${c.id}`} className={`font-black ${trend > 0 ? "text-emerald-600" : "text-red-500"}`} title={zh ? "最近一次 vs 此前均值" : "latest vs earlier avg"}>{trend > 0 ? `↑${trend}` : `↓${Math.abs(trend)}`}</span>}
        <span className="ml-auto inline-flex items-center gap-0.5 shrink-0" title={zh ? "最近评分（新 → 旧）" : "recent scores"}>
          {rs.slice(0, 5).map((r, i) => <i key={i} className={`inline-block w-1.5 rounded-sm ${r.score >= 4 ? "bg-emerald-500" : r.score >= 3 ? "bg-amber-400" : "bg-red-500"}`} style={{ height: 4 + r.score * 2 }} />)}
        </span>
        {rs.some((r) => r.comment) && (open ? <ChevronUp className="h-3 w-3 text-slate-400" /> : <ChevronDown className="h-3 w-3 text-slate-400" />)}
      </button>
      {!open && rs[0]?.comment && <p className="mt-0.5 text-slate-600 truncate" data-testid={`sc-pm-last-comment-${c.id}`}>“{rs[0].comment}” <span className="text-slate-400">· {rs[0].by} · {fmtD(rs[0].at)}</span></p>}
      {open && (
        <ul className="mt-1 space-y-0.5" data-testid={`sc-pm-comments-${c.id}`}>
          {rs.map((r, i) => (
            <li key={i} className="flex items-start gap-1.5 text-slate-600">
              <span className="font-bold text-amber-700 shrink-0">{r.score}★</span>
              <span className="flex-1">{r.comment ? `“${r.comment}”` : <span className="text-slate-400">{zh ? "无评语" : "no comment"}</span>}<span className="text-slate-400"> · {r.address ? String(r.address).split(",")[0] : ""} · {r.by} · {fmtD(r.at)}</span></span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
